import { Button, Col, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import config from '../../config.json';

import ClientSelect from '../../components/common/ClientSelect';
import auth from "../../services/authService";
import { getContracts, statsByStatus } from '../../services/contractService';
import ServicesTable from './ServicesTable';
import StatusBtn from './StatusBtn';

const { Title } = Typography;
const { contractStatuses } = config;

export default function Services() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [stats, setStats] = useState({});
	const [data, setData] = useState([]);

	const [activeStatus, setActiveStatus] = useState('');
	const [clientId, setClientId] = useState(null);

	useEffect(() => {
		setLoading(true);

		statsByStatus()
			.then(({ data }) => {
				const items = data.reduce((acc, item) => {
					acc[item.statusId] = item.count;
					return acc;
				}, {});
				setStats(items);
			}).finally(() => setLoading(false));
	}, []);

	useEffect(() => {
		// Exclude status if not in stats
		if((activeStatus === '' && !clientId) || (activeStatus !== '' && !stats[activeStatus])) {
			setData([]);
			return;
		}

		setLoading(true);
		
		getContracts(activeStatus, clientId, 0, null)
			.then(({ data }) => setData(data))
			.finally(() => setLoading(false));
	}, [activeStatus, clientId]);

	const clientChangeHandler = (clientId) => {
		setClientId(clientId);
		setActiveStatus('');
	};

	const statusBtnHandler = (status) => {
		setActiveStatus(status === activeStatus ? '' : status);
		setClientId(null);
	};

	return (
		<Row gutter={[24, 24]} style={{ marginTop: '2rem', marginLeft: '2rem', marginRight: '2rem' }}>
			<Col span={24}>
				<Title level={2}>Servicios</Title>
				<hr className="hr-title" />
			</Col>
			<Col span={24}>
				<Row gutter={[16, 32]} justify="space-between">
					{contractStatuses
						.filter(s => auth.isInRole(s.rol))
						.map(({ rol, ...rest }) => 
							<StatusBtn
								{...rest}
								key={rest.status}
								active={rest.status === activeStatus}
								count={stats[rest.status] || 0}
								disabled={loading}
								onClick={() => statusBtnHandler(rest.status)}
							/>)}
				</Row>
			</Col>
			<Col span={24}>
				<Row justify="space-between" align="middle">
					<Col>
						<ClientSelect
							allowClear
							value={clientId}
							style={{ width: 400 }}
							onChange={(clientId) => clientChangeHandler(clientId)} />
					</Col>
					<Col>
						<Button
							type="primary"
							shape="round"
							icon={<FaPlusCircle />}
							onClick={() => navigate('/intelinet/servicios/contrato')}
							disabled={!auth.isInRole("SERVICE_CREATE")}>
							&nbsp; Nuevo
						</Button>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<ServicesTable scroll={{ x: 'auto' }} dataSource={data} loading={loading} pagination={{ hideOnSinglePage: true }} />
			</Col>
		</Row>
	);
}
